import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../redux/axios";

const initialState = {
  isFetching: false,
  walletData: [],
  isSuccessWallet: false,
  isErrorWallet: false,
  errorMessageWallet: "",
  
  balanceData: null,
  isFetchingBalance: false,
  isSuccessBalance: false,
  isErrorBalance: false,
  errorMessageBalance: "",
};

export const walletUserData = createAsyncThunk(
  "wallet",
  async (udata = {}, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let body = udata.body ?? {};
      let searchParam = udata.query ? "?searchParameter=" + udata.query : "";
      let tokenStr = auth.user.accessToken;

      
      const response = await axios.post(
        "/reports/transactions" + searchParam,
        body,
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
          },
        }
      );

      let data = response;

      if (response.status === 200) {
        return data.data;
      } else if (response.status === 201) {
        return data.data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        console.error("err ===>", err);
        throw err;
      }

      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getBalanceData = createAsyncThunk(
  "wallet/getBalance",
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState();
      let tokenStr = auth?.user?.accessToken;
      
      const usernameHeader =
        (udata &&
          (udata.username ??
            udata.userName ??
            (typeof udata === "string" ? udata : null))) ??
        auth?.user?.username ??
        auth?.user?.userName ??
        auth?.user?.systemId ??
        "";

      const headers = {
        accept: "*/*",
      };
      if (tokenStr) {
        headers.Authorization = `Bearer ${tokenStr}`;
      }
      if (usernameHeader) {
        headers.username = usernameHeader;
      }

      const response = await axios.post(
        "/balance/getMyBalance",
        {},
        {
          headers,
        }
      );

      if (response.status === 200 || response.status === 201) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch (err) {
      const data =
        typeof err.response?.data === "object"
          ? err.response.data
          : { message: err.response?.data };
      return thunkAPI.rejectWithValue({
        ...data,
        status: err.response?.status,
      });
    }
  }
);

export const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    clearStateWallet: (state, { payload }) => {
      state.walletData = [];
      state.isFetching = false;
      state.isSuccessWallet = false;
      state.isErrorWallet = false;
      state.errorMessageWallet = "";
    },
    clearBalanceState: (state) => {
      state.balanceData = null;
      state.isFetchingBalance = false;
      state.isSuccessBalance = false;
      state.isErrorBalance = false;
      state.errorMessageBalance = "";
    },
  },
  extraReducers: (builder) => {
    builder
      

      .addCase(walletUserData.fulfilled, (state, action) => {
        state.walletData = action.payload;
        state.isFetching = false;
        state.isSuccessWallet = true;
        state.isErrorWallet = false; 
      })
      .addCase(walletUserData.pending, (state) => {
        state.isFetching = true;
        state.isErrorWallet = false;
        state.isSuccessWallet = false;
      })
      .addCase(walletUserData.rejected, (state, action) => {
        state.isFetching = false;
        state.isErrorWallet = true;
        state.isSuccessWallet = false; 
        state.errorMessageWallet = action.payload
          ? action.payload.message
          : "Internal error";
        
        state.walletData = {
          totalCreditAmount: 0,
          totalDebitAmount: 0,
          balanceEntry: {},
          currency: "",
          rechargeEntries: [],
          masterId: null,
        };
      })
      
      .addCase(getBalanceData.fulfilled, (state, action) => {
        state.balanceData = action.payload;
        state.isFetchingBalance = false;
        state.isSuccessBalance = true;
      })
      .addCase(getBalanceData.pending, (state) => {
        state.isFetchingBalance = true;
      })
      .addCase(getBalanceData.rejected, (state, action) => {
        state.isFetchingBalance = false;
        state.isErrorBalance = true;
        state.errorMessageBalance = action.payload
          ? action.payload.message
          : "Internal error";
      });
  },
});
export const { clearStateWallet, clearBalanceState } = walletSlice.actions;

export function clearStateWalletFn() {
  return async (dispatch) => {
    dispatch(clearStateWallet());
  };
}

export const walletSelector = (state) => state.wallet;

export default walletSlice.reducer;
